import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function Hero() {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('oferta');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="pt-[80px] pb-16 px-4 bg-white" data-id="element-132">
      <div className="max-w-4xl mx-auto text-center" data-id="element-133">
        {/* Badge */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center gap-2 bg-primary/10 text-primary px-4 py-2 rounded-full mb-6" data-id="element-134">
          <Sparkles className="w-4 h-4" data-id="element-135" />
          <span className="text-sm font-semibold" data-id="element-136">Sistema Mamá IA</span>
        </motion.div>

        {/* H1 */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="font-serif text-4xl md:text-5xl lg:text-6xl text-dark mb-6 leading-tight" data-id="element-137">
          Crea y vende tu primer PDF en 7 días usando solo tu celular
        </motion.h1>

        {/* Subheadline */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-body mb-8 max-w-3xl mx-auto" data-id="element-138">
          El primer método diseñado para mamás latinas que utiliza Inteligencia
          Artificial para crear, diseñar y lanzar un producto digital en una
          fracción del tiempo habitual.
        </motion.p>

        {/* CTA Button */}
        <motion.button initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.98
      }} onClick={scrollToOffer} className="shimmer-cta pulse-glow w-full md:w-auto px-8 py-4 rounded-lg text-white font-bold text-lg mb-4 cursor-pointer" data-id="element-139">
          ¡Lanza tu negocio en 7 días! →
        </motion.button>

        {/* Text below CTA */}
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-sm font-semibold text-dark mb-12" data-id="element-140">
          PAGO ÚNICO - SIN SUSCRIPCIONES
        </motion.p>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="max-w-md mx-auto" data-id="element-141">
          <img src="https://cdn.magicpatterns.com/uploads/7HgcExsbaBvwxnDg8uHySj/portada.webp" alt="Sistema Mamá IA - Portada del Producto" className="w-full rounded-lg shadow-2xl" data-id="element-142" />
        </motion.div>
      </div>
    </section>;
}